import { LitElement, html, css, unsafeCSS, property, svg } from "lit-element";

import broadcastLiveStatsStyles from "./broadcast-live-stats.scss";

import { reportsApi } from "../../api/reportsApi";
import { performanceMediaApi } from "../../api/performanceMediaApi";

import { MetricMatchModel } from "../../models/broadcast/metricMatchModel";
import { BroadcastTemplateModel } from "../../models/broadcast/broadcastTemplateModel";

import BroadcastLiveStatsHeader from "./header/broadcast-live-stats-header";
import BroadcastLiveStatsTeams from "./teams/broadcast-live-stats-teams";
import playersIcon from "../../assets/ic_rugbyplayer.svg";
import teamsIcon from "../../assets/ic_stats.svg";
import BroadcastLiveStatsPlayers from "./players/broadcast-live-stats-players";

export default class BroadcastLiveStats extends LitElement {
    @property({ type: Object })
    match: MetricMatchModel;

    @property({ type: Array })
    templates: BroadcastTemplateModel[];

    private _performanceMediaUrl = "";
    private _reportsUrl = "";
    private _userId = "";

    private _matchId: string;

    private _performanceMediaApi: performanceMediaApi;
    private _reportsApi: reportsApi;

    private _showPlayers: boolean = true;
    private _homeTeamColour: string;
    private _awayTeamColour: string;

    private viewingTeams: boolean = true;

    constructor(
        matchId: string,
        performanceMediaUrl: string,
        reportsUrl: string,
        userId: string,
        showPlayers: boolean = true,
        homeTeamColour: string = "",
        awayTeamColour: string = "") {
        super();

        this._matchId = matchId;
        this._performanceMediaUrl = performanceMediaUrl;
        this._reportsUrl = reportsUrl;
        this._userId = userId;
        this._performanceMediaApi = new performanceMediaApi(this._performanceMediaUrl, this._userId);
        this._reportsApi = new reportsApi(this._reportsUrl, this._userId);

        this._showPlayers = showPlayers;

        if (!homeTeamColour)
            homeTeamColour = "#e41f26";

        this._homeTeamColour = homeTeamColour;
        
        if (!awayTeamColour)
            awayTeamColour = "#141414";

        this._awayTeamColour = awayTeamColour;
    }

    async firstUpdated() {
        this.fetchStats();
    }

    async delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async fetchStats() {
        this.showLoading(true, document.querySelector('#loading-container'));

        [this.match, this.templates] = await Promise.all([this._performanceMediaApi.GetBroadcastStats(this._matchId), this._reportsApi.GetBroadcastTemplateFromReports(this._userId)]);

        this.showLoading(false, document.querySelector('#loading-container'));

        // If Match is not live, don't loop. Return
        if (this.match.status !== 5) {
            this.showLoading(false, document.querySelector('#loading-container'));
            return;
        }

        await this.delay(5000);
        await this.fetchStats();
    }

    renderStats() {
        return html`
            ${new BroadcastLiveStatsHeader(this.match, this._homeTeamColour, this._awayTeamColour)}
            <div class="change-view-row">
                <button class="btn switch-stats ${this._showPlayers ? '' : 'hidden'}" @click="${this.switchView}">
                    ${this.viewingTeams ? html`${playersIcon} View Player Stats` : html`${teamsIcon} View Team Stats`}
                    </button>
                </div>
            <div class="team-stats ${this.viewingTeams ? '' : 'hidden'}">
                ${new BroadcastLiveStatsTeams(this.match, this.templates, this._homeTeamColour, this._awayTeamColour)}
            </div>
            <div class="player-stats ${this.viewingTeams ? 'hidden' : ''}">
                ${new BroadcastLiveStatsPlayers(this.match, this.templates)}
            </div>
        `;
    }

    switchView = () => {
        this.viewingTeams = !this.viewingTeams;
        this.requestUpdate();
    }

    showLoading(isLoading: boolean, container: HTMLElement) {
        if (isLoading) {
            container.innerHTML = `<i class="fa fa-circle-o-notch fa-spin" style="margin-right: 5px;"></i> Loading Match Stats`;
        }
        else {
            container.innerHTML = "";
        }
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return [
            html`
            <style>
                ${css`${unsafeCSS(broadcastLiveStatsStyles)}`}                     
            </style>

            <div class="container">   

                <div id="loading-container" class="row">

                </div>

                ${(this.match && this.templates) ? this.renderStats() : ''} 

            </div>`
        ];
    }
}

window.customElements.define('broadcast-live-stats', BroadcastLiveStats as any);